import apiFetch from '../apiFetch'

export default function (entidad, token) {
  return apiFetch({endPoint: `Informes/getComboSeleccionesInformePersonalizado?entidad=` + entidad, method: 'GET', body: null, token: token})
}